"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var vizHoverOpacity = exports.vizHoverOpacity = "0.25";
var vizHoverFilter = exports.vizHoverFilter = "grayscale(0.8)";